
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"31","height":"31"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"data-name":"Path 7931","d":"M1128.924 497.383v5.083a2.843 2.843 0 01-.248 1.173 2.341 2.341 0 01-.765.978 3.548 3.548 0 01-1.292.638 6.126 6.126 0 01-1.82.239 4.7 4.7 0 01-3.1-.86 2.792 2.792 0 01-1.03-2.143v-14.047h2.541v3.588a.846.846 0 00.057.328 1.832 1.832 0 00.2.293 1.031 1.031 0 00.189.178l.178.088c.079.024.226.077.443.157.235.088.512.186.821.289.327.119.666.24 1.009.357s.647.224.915.314a2.645 2.645 0 011.423 1.12 3.216 3.216 0 01.472 1.711zm-5.71-.112v4.859a.974.974 0 00.068.357.944.944 0 00.213.33 1.26 1.26 0 00.463.242 2.572 2.572 0 00.841.118 2.755 2.755 0 00.8-.1 1.062 1.062 0 00.455-.24.848.848 0 00.235-.351 1.593 1.593 0 00.114-.461v-4.756a1.2 1.2 0 00-.113-.556 1.514 1.514 0 00-.286-.362 1.609 1.609 0 00-.448-.262 22.574 22.574 0 00-.749-.264 11.923 11.923 0 01-.722-.271 20.904 20.904 0 00-.721-.239c-.051-.014-.1-.032-.153-.051z","transform":"translate(-1087.299 -185.469)","fill":"#0b5898","clip-rule":"evenodd"}})])]),_c('g',{attrs:{"data-name":"Group 14143"}},[_c('g',{attrs:{"data-name":"Group 14142"}},[_c('g',{attrs:{"data-name":"Group 14141"}},[_c('g',{attrs:{"data-name":"Group 14140"}},[_c('g',{attrs:{"data-name":"Group 14139"}},[_c('g',{attrs:{"data-name":"Mask Group 2","clip-path":"url(#a)","transform":"translate(-22 -296)"}},[_c('path',{attrs:{"data-name":"Path 9778","d":"M37.5 298.5a13 13 0 11-13 13 13 13 0 0113-13z","fill":"#fff"}})]),_c('path',{attrs:{"data-name":"Path 7932","d":"M15.501 31a15.5 15.5 0 1115.5-15.5 15.517 15.517 0 01-15.5 15.5zm0-30a14.5 14.5 0 1014.5 14.5A14.517 14.517 0 0015.501 1z","fill":"#fff"}})])])])])])])
          )
        }
      }
    